export class ClsMapaKeyModel {
  public MK_EMPRESA_ID: number
  public MK_KEY_MAPS: string
  public MK_IP_EQUIPO: string
}
